var map = {
	"./banner-unico.png": [
		7554
	],
	"./banners-col.png": [
		8462,
		462
	],
	"./banners-mosaic.png": [
		7361,
		742
	],
	"./card.png": [
		450,
		450
	],
	"./carrossel-de-banner.png": [
		4635,
		635
	],
	"./carrossel-de-produtos-query.png": [
		2700,
		700
	],
	"./carrossel-de-produtos.png": [
		3435,
		435
	],
	"./carrossel-de-stories.png": [
		5694,
		694
	],
	"./colapse.png": [
		8579,
		579
	],
	"./colecao-vtex.png": [
		8518,
		518
	],
	"./default-preview.png": [
		1990,
		990
	],
	"./description.png": [
		5796,
		796
	],
	"./focus.png": [
		8662,
		662
	],
	"./highlight-filter.png": [
		2919,
		919
	],
	"./infinite-scroll.png": [
		3116,
		116
	],
	"./logo.png": [
		3153,
		153
	],
	"./media-youtube.png": [
		4418,
		418
	],
	"./placeholder.png": [
		8145,
		145
	],
	"./promocional-carrossel-de-banner.png": [
		6365,
		365
	],
	"./redirect-menu.png": [
		4110,
		110
	],
	"./redirect-title.png": [
		665,
		665
	],
	"./small-logo.png": [
		6883,
		883
	],
	"./table-products.png": [
		1969,
		969
	],
	"./topic.png": [
		6467,
		467
	],
	"./unique-product.png": [
		3151,
		151
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8388;
module.exports = webpackAsyncContext;